(function ($) {
    /**
     * Sticky nav class change.
     *
     * Adds a class to the main nav when the window is scrolled past
     * a certain point.
     *
     * @type {*|HTMLElement}
     */
    const body = $("body");

    function bodyScroll() {
        const scroll = $(window).scrollTop();

        if (scroll >= 75) {
            body.addClass("scrolled");
        } else {
            body.removeClass("scrolled");
        }
    }

    $(window).scroll(bodyScroll);

    bodyScroll();

    /**
     * Main Menu - Offcanvas Etc.
     */
    const hamburgerMenu = $('.hamburger');
    const wrapperClasses = $('body, html');

    hamburgerMenu.on('click', function (e) {
        $(e.currentTarget).toggleClass('active');
        wrapperClasses.toggleClass('nav-open');
    });

    // Close menu on "esc" key press.
    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            hamburgerMenu.removeClass('active');
            wrapperClasses.removeClass('nav-open search-open');
        }
    });
})(jQuery);
